/**
 * Winnre home-only config for Aloha.
 *
 * clientId matches the Aloha tenant in public/client-config.js so this resolves
 * at runtime when the app is built for the Aloha client.
 *
 * HOME-ONLY: defines just `routes.home.components[]`. Branding/other routes still
 * come from the server-injected config. `getConfig()` merges this `routes.home`
 * into the server THEME.
 *
 * Supported ComponentsRenderer types right now: TEXT, BANNER, IMAGE, SLIDER_BANNER.
 * Layout: a SLIDER_BANNER hero (dummy slide URLs — replace with real assets)
 * followed by the 6 responsive IMAGE banners (alternating desktop/mobile) that
 * mirror the Aloha home config served from the backend.
 */
const AlohaConfig = {
    clientId:
        '239c65cb76f499014d6585d35a253fa1d6a967239b6953701af8c8fe9d24c526',
    name: 'Aloha',
    routes: {
        home: {
            name: 'HOME',
            path: '/',
            show: true,
            components: [
                {
                    // SLIDER_BANNER hero — dummy data. Replace the url / mobileUrl
                    // of each slide with real assets. Each slide supports:
                    //   bannerImage: { url, mobileUrl }  (aspect-fit <img> mode)
                    //   onClick: 'CHANGE_PATH' | 'LINK' | 'SCROLL' | 'FUNC'
                    //   path / link / scrollTo, and optional text + components[]
                    type: 'SLIDER_BANNER',
                    slides: [
                        {
                            id: 0,
                            text: '',
                            path: '',
                            onClick: '',
                            bannerImage: {
                                url: 'https://cdn.loyalie.in/1789652116267_AP1W',
                                mobileUrl: 'https://cdn.loyalie.in/1789652037816_AP1M'},
                            linearGradient: {
                                R: '255',
                                G: '255',
                                B: '255',
                                opacity: '1'
                            }
                        },
                        {
                            id: 1,
                            text: '',
                            path: 'myProfile/invoice',
                            onClick: 'CHANGE_PATH',
                            bannerImage: {
                                url: 'https://cdn.loyalie.in/1789652131320_AP2W',
                                mobileUrl: 'https://cdn.loyalie.in/1789652048002_AP2M'
                            },
                            linearGradient: {
                                R: '255',
                                G: '255',
                                B: '255',
                                opacity: '1'
                            }
                        },
                        {
                            id: 2,
                            text: '',
                            path: 'projects',
                            onClick: 'CHANGE_PATH',
                            bannerImage: {
                                url: 'https://cdn.loyalie.in/1789652142241_AP3W',
                                mobileUrl: 'https://cdn.loyalie.in/1789652057457_AP3M'
                            },
                            linearGradient: {
                                R: '255',
                                G: '255',
                                B: '255',
                                opacity: '1'
                            },
                        },
                            {
                            id: 3,
                            text: '',
                            path: 'myprofile/customers',
                            onClick: 'CHANGE_PATH',
                            bannerImage: {
                                url: 'https://cdn.loyalie.in/1789652152438_AP4W',
                                mobileUrl: 'https://cdn.loyalie.in/1789652068291_AP4M'
                            },
                            linearGradient: {
                                R: '255',
                                G: '255',
                                B: '255',
                                opacity: '1'
                            }
                        }
                    ]
                },
                // {
                //     type: 'IMAGE',
                //     url: 'https://reloy-internal.s3.ap-south-1.amazonaws.com/ClientAssets/Aloha/WinnRE_Banner/New/Section_Web1.png',
                //     classNameContainer: 'hidden lg:block '
                // },
                // {
                //     type: 'IMAGE',
                //     url: 'https://reloy-internal.s3.ap-south-1.amazonaws.com/ClientAssets/Aloha/WinnRE_Banner/New/Section_Mob1.png',
                //     classNameContainer: 'block lg:hidden '
                // },
                {
                    type: 'IMAGE',
                    url: 'https://reloy-internal.s3.ap-south-1.amazonaws.com/ClientAssets/Aloha/WinnRE_Banner/New/Section_Web2.png',
                    classNameContainer: 'hidden lg:block '
                },
                {
                    type: 'IMAGE',
                    url: 'https://reloy-internal.s3.ap-south-1.amazonaws.com/ClientAssets/Aloha/WinnRE_Banner/New/Section_Mob2.png',
                    classNameContainer: 'block lg:hidden '
                },
                {
                    type: 'IMAGE',
                    url: 'https://reloy-internal.s3.ap-south-1.amazonaws.com/ClientAssets/Aloha/WinnRE_Banner/New/Section_Web3.png',
                    classNameContainer: 'hidden lg:block '
                },
                {
                    type: 'IMAGE',
                    url: 'https://reloy-internal.s3.ap-south-1.amazonaws.com/ClientAssets/Aloha/WinnRE_Banner/New/Section_Mob3.png',
                    classNameContainer: 'block lg:hidden '
                }
            ]
        }
    }
};

export default AlohaConfig;
